import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    overflowY: "auto",
  },
  tableWrapper: {
    paddingBlock: 12,
  },
  dataGridTable: {
    width: "100%",
    "& .MuiDataGrid-columnHeaders": {
      background: "#1D426D33",
      minHeight: 58,
      maxHeight: 58,
      lineHeight: 1.2,
    },
    "& .MuiDataGrid-columnHeader": {
      paddingTop: 8,
      paddingBottom: 8,
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 400,
      textTransform: "uppercase",
      fontSize: 12,
    },
    "& .MuiDataGrid-cell": {
      paddingTop: 12,
      paddingBottom: 12,
      alignItems: "center",
    },
    "& .MuiDataGrid-cellContent": {
      lineHeight: 1.35,
    },
    "& .MuiDataGrid-iconSeparator": {
      color: "#000 !important",
    },
    "& .MuiDataGrid-virtualScroller": {
      scrollbarWidth: "thin",
      "&::-webkit-scrollbar": {
        height: 8,
      },
    },
  },
  lightText: {
    "& .MuiTypography-root": {
      color: "rgba(0, 0, 0, 0.7)",
    },
  },
  iconsWrapper: {
    display: "flex",
    gap: 8,
  },
  editIcon: {
    display: "flex",
    alignItems: "center",
  },
  addBtn: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "10px 20px",
  },
  driverCell: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
    minWidth: 0,
  },
  driverPrimary: {
    fontWeight: 700,
    color: "#0f172a",
    lineHeight: 1.35,
  },
  driverSecondary: {
    fontSize: 13,
    color: "#64748b",
    lineHeight: 1.35,
  },
  detailsButton: {
    borderRadius: 5,
    fontWeight: 700,
    textTransform: "none",
  },
  summaryChip: {
    borderRadius: 999,
    fontWeight: 800,
  },
  dialogContent: {
    paddingTop: 12,
  },
  detailPanel: {
    border: "1px solid rgba(15, 23, 42, 0.08)",
    borderRadius: 18,
    padding: 16,
    background: "#ffffff",
    height: "100%",
  },
  detailPanelTitle: {
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: 14,
    fontSize: 15,
  },
  detailRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: 10,
    alignItems: "flex-start",
    padding: "8px 0",
    borderBottom: "1px dashed rgba(15, 23, 42, 0.08)",
    "&:last-child": {
      borderBottom: 0,
      paddingBottom: 0,
    },
  },
  detailLabel: {
    fontSize: 12,
    textTransform: "uppercase",
    letterSpacing: 0.6,
    color: "#64748b",
    fontWeight: 800,
    flex: "0 0 42%",
  },
  detailValue: {
    fontSize: 13,
    fontWeight: 700,
    color: "#0f172a",
    textAlign: "right",
    wordBreak: "break-word",
    flex: 1,
  },
  documentList: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },
  documentRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: 12,
    alignItems: "flex-start",
    padding: 14,
    border: "1px solid rgba(15, 23, 42, 0.08)",
    borderRadius: 16,
    background: "#f8fafc",
  },
  documentMain: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    minWidth: 0,
    flex: 1,
  },
  documentTitle: {
    fontWeight: 800,
    color: "#0f172a",
  },
  documentMeta: {
    fontSize: 12,
    color: "#64748b",
  },
  emptyState: {
    padding: 24,
    textAlign: "center",
    color: "#64748b",
  },
  detailDialog: {
    "& .MuiDialog-paper": {
      minHeight: "94vh",
      maxHeight: "94vh",
      minWidth: "90%",
      maxWidth: "90%",
      borderRadius: 0,
      overflow: "hidden",
      backgroundColor: "#ffffff",
    },
  },
  detailDialogTitle: {
    padding: "0 !important",
    backgroundColor: theme.palette.custom.main,
    color: "#fff",
  },
  detailTitleRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    padding: "8px 20px",
    minHeight: 56,
  },
  detailDialogTitleText: {
    color: "#fff",
    fontWeight: 500,
    fontSize: 15,
    lineHeight: 1.4,
  },
  detailCloseIcon: {
    color: "#fff",
  },
  detailTabsWrap: {
    borderBottom: "1px solid #e5e7eb",
    padding: "0 20px",
    backgroundColor: "#ffffff",
  },
  detailTabs: {
    minHeight: 42,
    "& .MuiTabs-indicator": {
      backgroundColor: theme.palette.primary.main,
      height: 2,
    },
    "& .MuiTab-root": {
      minHeight: 42,
      padding: "10px 0",
      marginRight: 28,
      minWidth: 0,
      fontSize: 13,
      fontWeight: 500,
      textTransform: "uppercase",
      letterSpacing: 0.2,
      color: "#7a7a7a",
      "&.Mui-selected": {
        color: theme.palette.primary.main,
      },
    },
  },
  detailDialogContent: {
    padding: "20px 20px 24px !important",
    overflowY: "auto",
    backgroundColor: "#ffffff",
  },
  detailTabPanel: {
    width: "100%",
  },
  detailHero: {
    width: "100%",
    height: 156,
    background: "#d7dee8",
    borderRadius: 10,
    display: "flex",
    justifyContent: "center",
    position: "relative",
    marginBottom: 116,
    [theme.breakpoints.down("sm")]: {
      height: 120,
      marginBottom: 90,
    },
  },
  detailHeroAvatarWrap: {
    position: "absolute",
    width: 170,
    height: 170,
    bottom: "-50%",
    left: "50%",
    transform: "translateX(-50%)",
    [theme.breakpoints.down("lg")]: {
      width: 156,
      height: 156,
    },
    [theme.breakpoints.down("md")]: {
      width: 140,
      height: 140,
    },
    [theme.breakpoints.down("sm")]: {
      width: 120,
      height: 120,
    },
  },
  detailHeroAvatar: {
    width: "100%",
    height: "100%",
    border: "1px solid rgba(29, 66, 109, 0.5)",
    borderRadius: "100%",
    background: "#f3f3f3",
    color: "#0f172a",
    fontWeight: 700,
    fontSize: 48,
  },
  detailHeroAvatarIcon: {
    position: "absolute",
    right: -4,
    top: "61%",
    width: 28,
    height: 28,
    borderRadius: "50%",
    backgroundColor: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.custom.main,
    "& .MuiSvgIcon-root": {
      fontSize: 28,
    },
  },
  detailSection: {
    border: "1px solid #e5e7eb",
    borderRadius: 14,
    background: "#ffffff",
    padding: 20,
    height: "100%",
  },
  detailSectionTitle: {
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: 16,
    fontSize: 16,
  },
  detailInfoGrid: {
    marginTop: 0,
  },
  infoField: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#ffffff",
    },
    "& .MuiInputLabel-root": {
      color: "#6b7280",
    },
  },
  documentSummary: {
    border: "1px solid #e5e7eb",
    borderRadius: 14,
    background: "#f8fafc",
    padding: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    flexWrap: "wrap",
  },
  summaryStat: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  summaryStatLabel: {
    fontSize: 12,
    color: "#64748b",
    textTransform: "uppercase",
    letterSpacing: 0.6,
    fontWeight: 700,
  },
  summaryStatValue: {
    fontSize: 22,
    fontWeight: 800,
    color: "#0f172a",
  },
  documentGrid: {
    marginTop: 0,
  },
  documentTablePaper: {
    border: "1px solid #e5e7eb",
    borderRadius: 6,
    overflow: "hidden",
    background: "#ffffff",
  },
  documentTableContainer: {
    maxHeight: "62vh",
    overflowY: "auto",
  },
  documentTable: {
    minWidth: 720,
  },
  documentTableHeadRow: {
    backgroundColor: "#edf7ef",
  },
  documentTableHeadCell: {
    padding: "18px 16px",
    color: theme.palette.primary.main,
    fontSize: 13,
    fontWeight: 800,
    textTransform: "uppercase",
    borderBottom: "1px solid #d7eadb",
  },
  documentTableBodyRow: {
    "&:last-child .MuiTableCell-root": {
      borderBottom: 0,
    },
  },
  documentTableBodyCell: {
    padding: "18px 16px",
    fontSize: 13,
    color: "#2f2f2f",
    borderBottom: "1px solid #e5e7eb",
    verticalAlign: "middle",
  },
  documentTableText: {
    fontSize: 13,
    color: "#2f2f2f",
    lineHeight: 1.4,
    wordBreak: "break-word",
  },
  documentTableStatus: {
    fontSize: 13,
    fontWeight: 500,
    lineHeight: 1.4,
    wordBreak: "break-word",
  },
  documentActions: {
    flexWrap: "wrap",
  },
  documentActionButton: {
    minWidth: 82,
    borderRadius: 10,
    borderColor: "#cfe3d5 !important",
    backgroundColor: "#f8fbf9 !important",
    color: `${theme.palette.primary.main} !important`,
    textTransform: "capitalize",
    fontWeight: 700,
    padding: "5px 16px !important",
    "&:hover": {
      borderColor: `${theme.palette.primary.main} !important`,
      backgroundColor: "#edf7ef !important",
    },
  },
  documentCard: {
    border: "1px solid #e5e7eb",
    borderRadius: 14,
    background: "#ffffff",
    padding: 16,
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  documentCardHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 12,
    marginBottom: 12,
  },
  documentCardMain: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
    minWidth: 0,
    flex: 1,
  },
  documentCardTitle: {
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.3,
    wordBreak: "break-word",
  },
  documentCardMeta: {
    fontSize: 12,
    color: "#64748b",
    lineHeight: 1.5,
    wordBreak: "break-word",
  },
  documentCardIcon: {
    width: 40,
    height: 40,
    borderRadius: 12,
    background: "#eef2ff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#4338ca",
    flex: "0 0 auto",
  },
  documentCardActions: {
    marginTop: "auto",
    display: "flex",
    justifyContent: "flex-end",
    paddingTop: 12,
  },
  statusCard: {
    border: "1px solid #e5e7eb",
    borderRadius: 14,
    background: "#ffffff",
    padding: 20,
  },
  statusHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
    marginBottom: 16,
  },
  statusHeadline: {
    fontSize: 18,
    fontWeight: 800,
    color: "#0f172a",
  },
  statusSubline: {
    color: "#64748b",
    fontSize: 13,
  },
  statusHistoryList: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },
  statusHistoryItem: {
    padding: 14,
    borderRadius: 12,
    border: "1px solid #e5e7eb",
    background: "#f8fafc",
  },
  statusHistoryTitle: {
    fontWeight: 700,
    color: "#0f172a",
  },
  statusHistoryMeta: {
    fontSize: 12,
    color: "#64748b",
    lineHeight: 1.5,
  },
  detailDialogActions: {
    padding: "12px 20px 20px !important",
    justifyContent: "flex-end",
    backgroundColor: "#ffffff",
  },
  closeButton: {
    backgroundColor: "#e5e5e5 !important",
    color: "#000 !important",
    borderRadius: 20,
    padding: "6px 20px !important",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#dcdcdc !important",
    },
  },
}));

export default useStyles;
